// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Playfair Display', 'Playfair Display Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_62f150","variable":"__variable_62f150"};